import { _APP_CONFIG } from "../../core/config/AppConfig";
import { IEscuelaProximidadRadarCfg } from "../../ui/ventana/Escuela/entidad/EscuelaProximidadRadarCfg";
import { DataDRequest } from "../DRequest";

export function svEscuelaObtenerConfiguracionProximidad(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + `escuela/ObtenerProximidadRadarConfiguracion`
    const params = {
        "IdEscuela": idEscuela
    }

    return DataDRequest._Request5<IEscuelaProximidadRadarCfg[]>(url, "GET", params);
}

export function svEscuelaConfigurarRadarProximidad(idEscuela: number, status: number, lat: number, lng: number, radioLlegada: number, radioZonaEscolar: number) {
    const url = _APP_CONFIG.URL_RSTV2 + "escuela/ConfigurarProximidadRadar"
    const params = {
        "IdEscuela": idEscuela,
        "Estado": status,
        "Latitud": lat,
        "Longitud": lng,
        "RadioLlegada": radioLlegada,
        "RadioZonaEscolar": radioZonaEscolar,
    }

    return DataDRequest._Request5(url, "POST", params);
}